import type { QueryClient } from '@tanstack/react-query';
import type { AgentsDataConfig } from '../../config';
import { getClientCapabilities } from '../../projects/clientCapabilities';

import { NO_COMPUTER_SELECTION } from './desktopTargetSelection';
import { fetchCurrentDesktopTarget } from './resolveDesktopTargetTurn';

type ResolveWorkflowRunRequestExtras = NonNullable<
  AgentsDataConfig['resolveWorkflowRunRequestExtras']
>;

type RunRequestExtrasInput = Parameters<ResolveWorkflowRunRequestExtras>[1];

/**
 * Sends the user's Run by pick for this run. Without one, the backend applies
 * the routine's preferred computer, then this computer, then these client
 * capabilities.
 */
// eslint-disable-next-line @heidi/rules/no-new-carved-domain-data -- app-side resolveRunRequestExtras binding: roster + Tauri caps cannot live in @heidi/agents/data; kept out of workflows/hooks.ts so the Green routines excludedSymbols ratchet does not grow
export const resolveWorkflowRunRequestExtras = async (
  queryClient: QueryClient,
  { desktopTargetOverride }: RunRequestExtrasInput,
  isDesktopTargetSelectorEnabled: () => boolean
) => {
  if (desktopTargetOverride && isDesktopTargetSelectorEnabled()) {
    return desktopTargetOverride === NO_COMPUTER_SELECTION
      ? { no_computer: true }
      : { target_id: desktopTargetOverride };
  }
  const target = await fetchCurrentDesktopTarget(queryClient).catch(() => undefined);
  if (target?.target_id) return { fallback_target_id: target.target_id };
  const capabilities = await getClientCapabilities().catch(() => null);
  return capabilities ? { client_capabilities: capabilities } : {};
};
